import React, { useState, useEffect } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

interface SubmenuToggleProps {
    isOpen: boolean;
    onToggle: (isOpen: boolean) => void;
}

const SubmenuToggle: React.FC<SubmenuToggleProps> = ({ isOpen, onToggle }) => {
    const [isMobile, setIsMobile] = useState(false);
    const [isTablet, setIsTablet] = useState(false);

    // Use the same device detection logic as the sidebar component
    useEffect(() => {
        const checkDevice = () => {
            const width = window.innerWidth;
            // Match sidebar component logic exactly:
            // - Mobile: < 768px
            // - Tablet: 768-1023px (iPad range, exclude 1024px)
            // - Desktop: >= 1024px
            const mobile = width < 768;
            const tablet = width >= 768 && width < 1024; // Exclude 1024px
            setIsMobile(mobile);
            setIsTablet(tablet);
           
        };

        checkDevice();
        window.addEventListener('resize', checkDevice);
        return () => window.removeEventListener('resize', checkDevice);
    }, []);

    const handleToggle = (e?: React.MouseEvent | React.TouchEvent) => {
        // Prevent default to avoid any conflicts
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        const newIsOpen = !isOpen;
       
        onToggle(newIsOpen);

        // Update main wrapper class for layout adjustments
        const mainWrapper = document.getElementById('main-wrapper');
        if (mainWrapper) {
            if (newIsOpen) {
                mainWrapper.classList.add('submenu-open');
            } else {
                mainWrapper.classList.remove('submenu-open');
            }
        }
    };

    // Don't render on desktop - only show on mobile/tablet
    if (!isMobile && !isTablet) {
       
        return null;
    }

   
    return (
        <button
            className="submenu-toggle mobile-submenu-toggle"
            onClick={handleToggle}
            onTouchEnd={handleToggle}
            aria-label={isOpen ? 'Close submenu' : 'Open submenu'}
            title={isOpen ? 'Close submenu' : 'Open submenu'}
            style={{
                // Ensure visibility for debugging
                display: 'flex',
                visibility: 'visible',
                opacity: 1
            }}
        >
            {isOpen ? <FaChevronLeft size={16} /> : <FaChevronRight size={16} />}
        </button>
    );
};

export default SubmenuToggle;
